import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WarningBanner } from './BunkerRob.styles';

export type BunkerRefWarningLevel = 'none' | 'atLimit' | 'exceeded';

interface BunkerRobWarningBannerProps {
    bunkerRefCount: number;
    maxBdnCount: number;
    warningLevel: BunkerRefWarningLevel;
}

const BunkerRobWarningBanner: React.FC<BunkerRobWarningBannerProps> = ({ bunkerRefCount, maxBdnCount, warningLevel }) => {
    const isExceeded = warningLevel === 'exceeded';

    return (
        <WarningBanner $severity={warningLevel}>
            <FontAwesomeIcon icon={isExceeded ? 'exclamation-circle' : 'exclamation-triangle'} />
            <span>
                {isExceeded ? (
                    <>
                        Error: {bunkerRefCount} bunker references on board. Maximum {maxBdnCount} allowed for automated DNV reporting. Report export
                        will fail until reduced.
                    </>
                ) : (
                    <>
                        Warning: {bunkerRefCount} bunker references on board (at reporting limit). Consider setting spent bunkers to zero and ensure
                        spent status.
                    </>
                )}
            </span>
        </WarningBanner>
    );
};

export default BunkerRobWarningBanner;
